<template>
  <lsm-widget
    icon="fa-bullhorn"
    data-testid="experience-widget"
    :title="t('experience.todays')"
    :subtitle="experience.title"
  >
    <div class="font-weight-bold mb-2">
      {{ toLongDate(props.experience.date) }} - {{ props.experience?.location?.name }}
    </div>
    <div>
      <rich-text-content
        class="text-start"
        :data="experienceText"
      />
      <router-link
        class="text-primary text-decoration-none"
        :to="`/experiences/${experience.id}`"
        :text="t('global.read_more')"
      />
    </div>
    <template #buttons>
      <v-btn
        to="/experiences"
        :text="t('experience.read_more')"
        color="primary"
      />
    </template>
  </lsm-widget>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import RichTextContent from '@/components/rich-text/RichTextContent.vue';
import { useDate } from '@/composables';
import LsmWidget from './LsmWidget.vue';

const props = defineProps<{
  experience: App.Models.Experience;
}>();

const { t } = useI18n();

const { toLongDate } = useDate();

function truncate(str: string, n: number) {
  return (str.length > n)
    ? `${str.substr(0, n - 1)}...`
    : str;
}

const experienceText = computed(() => truncate(props.experience.experience, 80));
</script>
